import React, { FunctionComponent } from 'react';
import { Box } from '@mui/material';
import { useLocale } from '../../contexts/LocaleProvider';
import { IntlProvider } from 'react-intl';

import { BrandsProvider } from '../../graphql/pimcore/modules/resourceLibrary/contexts/BrandsProvider';
import pimcoreClient from '../../graphql/pimcore/apollo/pimcoreClient';
import YageoGroupHome from './YageoGroupHome';

import { useAboutYageoGroupOverviewContent } from '../../graphql/pimcore/modules/siteContent/hooks/useAboutYageoGroupOverviewContent';
import DebouncedLoader from '../common/DebouncedLoader';

const YageoGroupPage: FunctionComponent = () => {
    const { locale, messages } = useLocale();
    const { loading, error, contentTree } = useAboutYageoGroupOverviewContent();

    return (
        <DebouncedLoader loading={loading} delay={1000} size={40} centered>
            <IntlProvider locale={locale} key={locale} defaultLocale="en" messages={messages}>
                <BrandsProvider apolloClient={pimcoreClient}>
                    <Box
                        width="100%"
                        component="main"
                        sx={{
                            padding: 0,
                            flexGrow: 0,
                            p: 0,
                        }}
                    >
                        <YageoGroupHome cmsContent={contentTree} />
                    </Box>
                </BrandsProvider>
            </IntlProvider>
        </DebouncedLoader>
    );
};
export default YageoGroupPage;
